import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const storage = getStorage();

export default function useFileUpload() {
  const uploadFile = async (file) => {
    if (!file) return null;

    // Create a unique path for each upload
    const filePath = `uploads/${Date.now()}_${file.name}`;

    const fileRef = ref(storage, filePath);

    await uploadBytes(fileRef, file);

    const url = await getDownloadURL(fileRef);

    return { url, fileName: file.name };
  };

  return { uploadFile };
}
